module.exports = __webpack_public_path__ + "static/media/georgiaz.2fccff89.woff";